define('lq/datasources',[
    'jquery',
    'underscore',
    'lq/queryDispatcher',
    'lq/util'
], function ($, _, QueryDispatcher, util) {
    'use strict';

    var Datasources = function () {
        this.datasourceListeners = [];
        this.datasources = [];
        this.updatableDatasourcesWithListeners = [];
    };

    Datasources.prototype.registerDatasourceListener = function (queryName, handler, decorateDataFunc, deleteHandler) {
        var id = _.uniqueId();
        this.datasourceListeners.push({
            id: id,
            queryName: queryName,
            handler: handler,
            decorateDataFunc: decorateDataFunc,
            deleteHandler: deleteHandler || $.noop
        });
        return id;
    };

    Datasources.prototype.registerDatasourceListenerOnce = function (queryName, handler, decorateDataFunc, deleteHandler, rootMorhpId) {
        if (_.contains(this.updatableDatasourcesWithListeners, rootMorhpId)) return;

        this.updatableDatasourcesWithListeners.push(rootMorhpId);
        return this.registerDatasourceListener(queryName, handler, decorateDataFunc, deleteHandler);
    };

    Datasources.prototype.getDatasourceListenersThatListenFor = function (queryName) {
        return _.where(this.datasourceListeners, { queryName: queryName });
    };

    Datasources.prototype.getDatasourceListenersThatListenForWithDefaultParams = function (queryName) {
        var defaultParams = QueryDispatcher.getDefaultQueryParams();
        return _.filter(this.getDatasourceListenersThatListenFor(queryName), function (listener) {
            if (typeof (listener.decorateDataFunc) !== "function")
                return true;
            var params = QueryDispatcher.getDefaultQueryParams();
            listener.decorateDataFunc(params);
            return _.isEqual(defaultParams, params);
        });
    };

    Datasources.prototype.unregisterDatasourceListener = function (id) {
        var listenerToRemove = this.getDatasourceListener(id);
        this.datasourceListeners = _.without(this.datasourceListeners, listenerToRemove);
    };

    Datasources.prototype.getDatasourceListener = function (id) {
        return _.findWhere(this.datasourceListeners, { id: id });
    };

    Datasources.prototype.registerDatasource = function (datasource) {
        if (datasource.data.id != null) {
            _.each(datasource.data.outputs, function (output, index) {
                datasource.data.outputs[index] = util.convertListOfKeyValuesToObject(output);
            });
            this.datasources.push(datasource);
        }
    };

    Datasources.prototype.getDatasources = function () {
        return util.cloneData(_.pluck(this.datasources, 'data'));
    };

    Datasources.prototype.getDatasourceNames = function (datasourceTypesToIgnore) {
        return _.chain(this.datasources)
            .filter(function (d) {
                return !!d.data.name && (!datasourceTypesToIgnore || datasourceTypesToIgnore.indexOf(d.data.type) === -1);
            })
            .groupBy(function(d) {
                return d.data.name;
            })
            .map(function (datasources, datasourceName) {
                var isUnique = datasources.length === 1;
                return {
                    type: isUnique ? datasources[0].data.type : null,
                    name: datasourceName,
                    unique: isUnique,
                    renderInBackground: _.every(datasources, function(datasource) { return datasource.renderInBackground; })
                };
            })
            .sortBy(function (d) {
                return d.name.toLowerCase();
            })
            .value();
    };

    Datasources.prototype.getDatasourceByName = function (dataSourceName) {
        return _.find(this.datasources, function (datasource) {
            return datasource.data.name === dataSourceName;
        });
    };

    Datasources.prototype.getEntityTypeOfDatasource = function (dataSourceName) {
        var datasource = this.getDatasourceByName(dataSourceName);
        return datasource ? datasource.data.entityDefinitionName : null;
    };

    Datasources.prototype.getDatasourceOutputs = function (dataSource, keepOriginalOrder, type) {
        if ($.type(dataSource) === 'string')
    	    dataSource = this.getDatasourceByName(dataSource);

    	if (!dataSource)
            return [];

        if (dataSource.getDatasourceOutputs)
            return dataSource.getDatasourceOutputs();

        var chain = _.chain(dataSource.data.outputs)
            .filter(function (output) {
                return !output.hideField && output.alias && (!type || output.outputType === type);
            })
            .pluck('alias');

        if (!keepOriginalOrder) {
            chain = chain.sortBy(function (a) {
                return a.toLowerCase();
            });
        }

        return chain.value();
    };

    Datasources.prototype.updateDatasource = function (datasource) {
    	this.unregisterDatasource(datasource);
        this.registerDatasource(datasource);
    };

    Datasources.prototype.unregisterDatasource = function (datasource) {
        this.datasources = _.filter(this.datasources, function (d) { return d.data.id !== datasource.data.id; });
    };

    Datasources.prototype.clear = function () {
        this.datasourceListeners = [];
        this.datasources = [];
    };

    return Datasources;
});
